import { render } from "./clere-footer.vue?vue&type=template&id=5f826bc5&scoped=true"
import script from "./clere-footer.vue?vue&type=script&lang=ts"
export * from "./clere-footer.vue?vue&type=script&lang=ts"

import "./clere-footer.vue?vue&type=style&index=0&id=5f826bc5&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-5f826bc5"

export default script